import strings from '../../../../../../localization';

// Keys are the AI onboarding profile property names sent as `editedProps`.
// Labels are read at call time so they follow the admin's current language.
const editedPropLabels: Record<string, () => string> = {
  role: () =>
    strings.role,
  preferdLanguage: () =>
    strings.preferredLanguage,
  firstName: () =>
    strings.firstName,
  lastName: () =>
    strings.lastName,
  professionalCapacityId: () =>
    strings.professionalCapacity,
  licenseNumber: () =>
    strings.licenseNo,
  graduationYear: () =>
    strings.yearLicensed,
  yearsOfExperience: () =>
    strings.yearsOfExperience,
  diploma: () =>
    strings.diploma,
  instituteName: () =>
    strings.educationalInstitute,
  techGraduationYear: () =>
    strings.graduationYear,
  englishLevel: () =>
    strings.englishLevel,
  frenchLevel: () =>
    strings.frenchLevel,
  otherLanguages: () =>
    strings.otherLanguage,
  address: () =>
    strings.address,
  city: () =>
    strings.city,
  province: () =>
    strings.province,
  postalCode: () =>
    strings.postalCode,
  phone: () =>
    strings.homePhone,
  mobile: () =>
    strings.mobile,
  incorporated: () =>
    strings.areYouIncorporated,
  isDSQKeyAvailable: () =>
    strings.doYouHaveOwnDsqKey,
  isMethadonePrepKnowledge: () =>
    strings.familiarWithMethadonePreparation,
  isComfortDispillVerification: () =>
    strings.comfortableWithDispillVerification,
  availabilityReminder: () =>
    strings.availabilityReminder,
  remoteRegion: () =>
    strings.remoteRegions,
  selectedContactPreferences: () =>
    strings.selectedContactPreference,
  selectedSoftwares: () =>
    strings.software,
  preferredWorkingDays: () =>
    strings.preferredWorkingDays,
  preferredReplacementDuration: () =>
    strings.preferredReplacementDuration,
  preferredDistanceRange: () =>
    strings.preferredDistanceRadius,
};

const technicianEditedPropLabels: Record<string, () => string> = {
  graduationYear: () =>
    strings.techExperienceSince,
};

export const getEditedPropLabel = (propName: string, isTechnician: boolean) => {
  const technicianLabel = isTechnician
    ? technicianEditedPropLabels[propName]
    : null;
  const getLabel = technicianLabel ?? editedPropLabels[propName] ?? null;

  return getLabel?.() ?? propName;
};
